import axios from 'axios';
import { TAXES_ENDPOINT } from '@/constants/endpoints'; // I need to define TAXES_ENDPOINT
import authHeader from "@/services/auth-header";
import QueryUtils from "@/utils/QueryUtils";
import Page from "@/dto/taxation/Page";
import TaxEventDTO from "@/dto/tax/TaxEventDTO";
import TaxEventFilter from "@/dto/tax/TaxEventFilter";
import TaxEventPayload from "@/dto/tax/TaxEventPayload";
import TaxEventCommentPayload from "@/dto/tax/TaxEventCommentPayload";
import TaxEventLedgerPayload from "@/dto/tax/TaxEventLedgerPayload";
import TaxEventReconciliationPayload from "@/dto/tax/TaxEventReconciliationPayload";

class TaxEventService {
    getTaxEvents(filter: TaxEventFilter) {
        // Backend takes 0-indexed page number if it maps to Spring Data Pageable
        // Assuming we need to adjust standard pageNumber from 1-indexed to 0-indexed
        const filterCopy = { ...filter, pageNumber: filter.pageNumber > 0 ? filter.pageNumber - 1 : 0 };
        const queryString = QueryUtils.objectToQueryString(filterCopy);
        return axios.get<Page<TaxEventDTO>>(`${TAXES_ENDPOINT}${queryString}`, { headers: authHeader() });
    }

    createTaxEvent(payload: TaxEventPayload) {
        return axios.post<TaxEventDTO>(`${TAXES_ENDPOINT}`, payload, { headers: authHeader() });
    }

    getTaxEvent(id: number) {
        return axios.get<TaxEventDTO>(`${TAXES_ENDPOINT}/${id}`, { headers: authHeader() });
    }

    updateTaxEvent(id: number, payload: TaxEventPayload) {
        return axios.put<TaxEventDTO>(`${TAXES_ENDPOINT}/${id}`, payload, { headers: authHeader() });
    }

    addComment(id: number, payload: TaxEventCommentPayload) {
        return axios.post<TaxEventDTO>(`${TAXES_ENDPOINT}/${id}/comments`, payload, { headers: authHeader() });
    }

    addLedgerRecord(id: number, payload: TaxEventLedgerPayload) {
        return axios.post<TaxEventDTO>(`${TAXES_ENDPOINT}/${id}/ledger`, payload, { headers: authHeader() });
    }

    addReconciliationRecord(id: number, payload: TaxEventReconciliationPayload) {
        return axios.post<TaxEventDTO>(`${TAXES_ENDPOINT}/${id}/reconciliation`, payload, { headers: authHeader() });
    }
}

export default new TaxEventService();
